import { error } from "@sveltejs/kit";

export async function load({ params, parent }) {
  const { speakers } = await parent();
  const speaker = speakers.find((s) => s.slug === params.slug);

  if (!speaker) {
    error(404);
  }

  return {
    speaker,
  };
}
